import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, ObjectiveFlag, DBRadioButton } from '_components';
import styles from './Common.module.css'

class SpeechReceptiveLanguage extends React.Component {

    render() {
        return (
            <div>

                <div className={styles.formRowSetting}>
                <div className={styles.flgCol}>
                     <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Receptive Language' />
                    </div>
                    <div className={styles.colHeader}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECSTATUS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
                    </div>

                    <div className={styles.formRowSetting}>
                    <div className={styles.flgCol} />
                    <div className={styles.colHeader}>
                        Comments
                    </div>
                    </div>
                <div className={styles.formRowSetting}>
                <div className={styles.col} />
                <div className={styles.colRadio}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSRECCOMMENTS'
                        className={styles.textarea}
                    />
                    </div>
                </div>

                <div className={styles.formRowSetting}>
                   <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.objFlagged} flagText='Identification of Objects' />
                   </div>

                   <div className={styles.colHeader}>
                   <b>Identification of Objects</b>
                   </div>
                    
                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECOBJECTS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECOBJECTS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol} />
                    <div className={styles.colHeader}>
                       <b>Reading Comprehension</b> 
                    </div>
                 </div>
        
                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.symFlagged} flagText='Symbols' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Symbols
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECSYMBOLS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECSYMBOLS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.wordFlagged} flagText='Words' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Words
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECWORDS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECWORDS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>



                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                       <ObjectiveFlag className={styles.flag} flagged={this.props.phraseFlagged} flagText='Phrases' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Phrases
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECPHRASES'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECPHRASES'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                     <ObjectiveFlag className={styles.flag} flagged={this.props.sentenceFlagged} flagText='Sentences' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Sentences
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECSETENCES'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECSETENCES'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.paraFlagged} flagText='Paragraphs' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Paragraphs
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECPARAGRAPHS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECPARAGRAPHS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                      <ObjectiveFlag className={styles.flag} flagged={this.props.funcMaterialFlagged} flagText='Functional Material' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Functional Material
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECFUNCMATERIAL'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECFUNCMATERIAL'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>

                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol} />
                    <div className={styles.colHeader}>
                       <b>Auditory Comprehension</b> 
                    </div>
                 </div>


                 <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.bodyPartsFlagged} flagText='Body Parts' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Body Parts
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECBODYPARTS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECBODYPARTS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                       <ObjectiveFlag className={styles.flag} flagged={this.props.YNQuestionFlagged} flagText='Yes/No Questions' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Yes/No Questions
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECYESNO'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECYESNO'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                       <ObjectiveFlag className={styles.flag} flagged={this.props.paraLevelFlagged} flagText='Paragraph Level' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Paragraph Level
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECPARALEVEL'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECPARALEVEL'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.conversationFlagged} flagText='Conversation' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Conversation
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECCONVERSATION'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECCONVERSATION'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>



                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}/>
                    
                   <div className={styles.colInnerHeader}>
                     <b>Follow Commands</b> 
                    </div>
 
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}/>
                <div className={styles.colInnerFlag}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.oneStepFlagged} flagText='One Step' />
                   </div>

                   <div className={styles.colNestedHeader}>
                       One Step
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECONESTEP'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECONESTEP'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}/>
                <div className={styles.colInnerFlag}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.twoStepFlagged} flagText='Two Step' />
                   </div>

                   <div className={styles.colNestedHeader}>
                       Two Step
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECTWOSTEP'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECTWOSTEP'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}/>
                <div className={styles.colInnerFlag}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.threeStepFlagged} flagText='Three Step' />
                   </div>

                   <div className={styles.colNestedHeader}>
                       Three Step
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECTHREESTEP'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECTHREESTEP'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}/>
                    
                   <div className={styles.colInnerHeader}>
                     <b>Yes/No Responses</b> 
                    </div>
 
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}/>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.simpleStepFlagged} flagText='Simple' />
                   </div>

                   <div className={styles.colNestedHeader}>
                       Simple
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECSIMPLE'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECSIMPLE'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}/>
                <div className={styles.colInnerFlag}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.complexStepFlagged} flagText='Complex' />
                   </div>

                   <div className={styles.colNestedHeader}>
                       Complex
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECCOMPLEX'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSRECCOMPLEX'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSTATUS !== 'WNL'),
        objFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECOBJECTS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECOBJECTS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECOBJECTS !== 'WNL'),
        symFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSYMBOLS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSYMBOLS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSYMBOLS !== 'WNL'),
        wordFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECWORDS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECWORDS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECWORDS !== 'WNL'),
        phraseFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECPHRASES !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECPHRASES !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECPHRASES !== 'WNL'),
        sentenceFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSETENCES !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSETENCES !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSETENCES !== 'WNL'),
        paraFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECPARAGRAPHS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECPARAGRAPHS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECPARAGRAPHS !== 'WNL'),
        funcMaterialFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECFUNCMATERIAL !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECFUNCMATERIAL !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECFUNCMATERIAL !== 'WNL'),
        bodyPartsFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECBODYPARTS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECBODYPARTS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECBODYPARTS !== 'WNL'),
        YNQuestionFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECYESNO !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECYESNO !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECYESNO !== 'WNL'),
        paraLevelFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECPARALEVEL !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECPARALEVEL !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECPARALEVEL !== 'WNL'),
        conversationFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECCONVERSATION !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECCONVERSATION !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECCONVERSATION !== 'WNL'),
        oneStepFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECONESTEP !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECONESTEP !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECONESTEP !== 'WNL'),
        twoStepFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECTWOSTEP !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECTWOSTEP !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECTWOSTEP !== 'WNL'),
        threeStepFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECTHREESTEP !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECTHREESTEP !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECTHREESTEP !== 'WNL'),
        simpleStepFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSIMPLE !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSIMPLE !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECSIMPLE !== 'WNL'),
        complexStepFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECCOMPLEX !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECCOMPLEX !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSRECCOMPLEX !== 'WNL'),
    };
}

const connectedSpeechReceptiveLanguage = connect(mapStateToProps)(SpeechReceptiveLanguage);
export { connectedSpeechReceptiveLanguage as SpeechReceptiveLanguage };


